import { render } from "./V-Calendar.vue?vue&type=template&id=37c9a5a2"
import script from "./V-Calendar.vue?vue&type=script&lang=js"
export * from "./V-Calendar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jean/Desktop/Git-project/distell_invoice_backend_dist/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__